import {
  createProduct,
  deleteProduct,
  getProduct,
  getProducts,
  updateProduct,
} from '@/api/productApi';
import type {
  CreateProductRequest,
  Product,
  UpdateProductRequest,
} from '@/types/product';

export const productService = {
  getProducts: async (): Promise<Product[]> => getProducts(),
  getProduct: async (id: string): Promise<Product> => getProduct(id),
  createProduct: async (data: CreateProductRequest): Promise<Product> =>
    createProduct(data),
  updateProduct: async (
    id: string,
    data: UpdateProductRequest,
  ): Promise<Product> => updateProduct(id, data),
  deleteProduct: async (id: string): Promise<void> => deleteProduct(id),
};
